import setInGameCurrency from "@workspace/casino_pages/legacyLayer/actions/Games/setInGameCurrency";
import getUserBalance from "@workspace/casino_pages/legacyLayer/server/graphql/getUserBalance";
import { useCallback, useEffect, useMemo, useState } from "react";
import getCurrencyDisplayIcon from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/helpers/getCurrencyDisplayIcon";
import useSetWalletCurrency from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/SwitchCurrencyNotification/hooks/useSetWalletCurrency";

const useSwitchCurrencyNotification = ({
  onClose,
  context,
  notification,
}: NotificationViewProps) => {
  const { currency = "USDT" } = notification.data ?? {};
  const [currentWalletCurrency, setCurrentWalletCurrency] = useState(
    context.currencyConfig.name,
  );
  const { setWalletCurrency } = useSetWalletCurrency(
    currentWalletCurrency,
    currency,
  );
  useEffect(() => {
    updateWalletCurrency();
  }, []);

  const updateWalletCurrency = async () => {
    const { currency: newWalletCurrency } = await getUserBalance();
    setCurrentWalletCurrency(newWalletCurrency);
  };

  const handleCurrencyChange = useCallback(async () => {
    await setInGameCurrency(currency);
    await setWalletCurrency();
    setCurrentWalletCurrency(currency);
    window.dispatchEvent(new CustomEvent("currencySwitched"));
    onClose();
  }, [setWalletCurrency, currency, onClose]);

  const isUbtcEnabled = context.currencyConfig.isUbtcEnabled;
  const walletCurrencyIcon = context.currencyConfig.icon;
  const currencyIcon = getCurrencyDisplayIcon(currency, isUbtcEnabled);
  const values = useMemo(
    () => ({
      walletCurrency: walletCurrencyIcon,
      currency: currencyIcon,
    }),
    [walletCurrencyIcon, currencyIcon],
  );
  return { handleCurrencyChange, values };
};

export default useSwitchCurrencyNotification;
